// frontend/src/components/Layout/MainLayout.jsx
import React from 'react';
import Navbar from '../Common/Navbar';
import Footer from '../Common/Footer';
import './MainLayout.css';

const MainLayout = ({ children }) => {
  return (
    <div className="main-layout">
      <Navbar />
      
      <main className="main-content">
        {children}
      </main>
      
      <Footer />
    </div>
  );
};

export default MainLayout;